// extracted by mini-css-extract-plugin
export default {"login":"Login_login__7t2tR","left":"Login_left__-LHrD","right":"Login_right__fKnkd"};